/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Box, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { MintlifyWidget } from '@mintlify/widget-react';

import { environment } from '@fai/friendli-suite/shared/environments/environment';

function DocsWidget() {
  const isBreakpoint = useMediaQuery(`(max-width: 81.25rem)`);

  return (
    <Box visibleFrom="xs" miw={isBreakpoint ? rem(156) : rem(256)}>
      <MintlifyWidget
        connection={{ apiKey: environment.MINTLIFY_API_KEY ?? '' }}
        display={{
          trigger: { type: 'input' },
          colors: { primary: '#2E70FF', primaryLight: '#4F87FF' },
          chat: {
            exampleQueries: [
              'Friendli Dedicated Endpoints',
              'Friendli Container',
              'Friendli Serverless Endpoints',
              'Friendli Token',
              'Supported Models',
              'Pricing',
              'Integrations',
              'API Reference',
              'Built-in tools',
              'friendli-client',
            ],
          },
        }}
      />
    </Box>
  );
}

export default DocsWidget;
